import { render, staticRenderFns } from "./HoverEnabler.vue?vue&type=template&id=28b6d660&"
import script from "./HoverEnabler.vue?vue&type=script&lang=ts&"
export * from "./HoverEnabler.vue?vue&type=script&lang=ts&"
import style0 from "./HoverEnabler.vue?vue&type=style&index=0&id=28b6d660&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports